import { type LogsBeforeSend } from '@datadog/browser-logs';

type LogsBeforeSendContext = NonNullable<Parameters<LogsBeforeSend>[1]>;

export const hasAbortedRequestContext = (context: LogsBeforeSendContext): boolean =>
  'isAborted' in context && context.isAborted === true;
